// @flow
import React from 'react';
import numbro from 'numbro';
import sv from 'numbro/languages/sv-SE';

const formatter = numbro.culture('sv-SE', sv).culture('sv-SE');

export type Props = {
  value: number | string,
  unit?: number | string,
  className?: string,
};

const FormattedPrice = ({value, unit, className}: Props) => (
  <span className={className}>
    {formatter(value).formatCurrency('0,0.[00] $')}{!!unit ? ` / ${unit}` : ''}
  </span>
);

export default FormattedPrice;



// WEBPACK FOOTER //
// ./src/components/FormattedPrice/FormattedPrice.js